// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__6mUwl","colBig":"styles_colBig__2bL1G","colSmall":"styles_colSmall__2KVqk"};